let $mapWrapper = $('.js-map');
let $mapItems = $('.js-marker-popup');
let map;
let $markersPopup;
let mapCenter;
let mapZoom = $mapWrapper.data('zoom') ? parseInt($mapWrapper.data('zoom')) : 10;

export function setHeightScrollBar() {

    $mapItems.find('.js-scroll.scrollbar-inner').each(function (index, el) {
        let _height = $(el).parent().outerHeight();

        if (_height >= $('.markers-wrapper').outerHeight()) {
            $(el).css({
                height: _height - 90
            });
        }
    });
}

/* Генерация карты, добавление объектов и генерация событий */
function generateMapData() {
    ymaps.ready(function() {
        // Определяем центр
        let ctr = $mapWrapper.data('center');
        let lat, lng;

        try {
            lat = parseFloat(ctr.split(',')[0]);
            lng = parseFloat(ctr.split(',')[1]);
        } catch (error) {}

        if (!!lat && !!lng) {
            mapCenter = [lat, lng];
        }


        // Инициализируем
        map = new ymaps.Map($mapWrapper[0], {
            center: mapCenter ? mapCenter : [59.94, 30.32],
            controls: [],
            zoom: mapZoom,
            type: 'yandex#satellite'// Тип покрытия карты: "Спутник".
        });

        if (App.mobile) {
            map.behaviors.disable('drag');
        }

        map.behaviors.disable('scrollZoom');

        generateMarkers($mapItems, map);
        addZoomControls(map);
    });

    $markersPopup = $('.js-marker-popup');
}

if ($mapWrapper.length) {
    generateMapData();
}

/* Закрытие попапа-баллуна */
$('.js-close-popup-map').on('click', function () {
    $(this).closest('.js-marker-popup').removeClass('_open');
});


/* добавляем кнопки зума на карту */
function addZoomControls(_map) {
    $mapWrapper.append(`
        <div class="zoom-controls">
            <div class="map-zoom _in js-zoom-in rrr"></div>
            <div class="map-zoom _out js-zoom-out rrr"></div>
        </div>
    `);

    const $plus = $mapWrapper.find('.js-zoom-in');
    const $minus = $mapWrapper.find('.js-zoom-out');


    // Кастомные кнопки
    $plus.on('click.map', e => {
        e.preventDefault();
        _map.setZoom(_map.getZoom() + 1);
    });

    $minus.on('click.map', e => {
        e.preventDefault();
        _map.setZoom(_map.getZoom() - 1);
    });
}

/* генерируем и располагаем на карте маркеры */
function generateMarkers(_markerPopups, _map) {
    let _lat;
    let _lng;
    let allPlacemarks = [];

    // обходим все метки, берем их коорднаты и размешаем метки на карте
    _markerPopups.each(function (index, el) {
        let $currEl = $(el);
        let _id = index;
        let currType = $currEl.data('type') ? $currEl.data('type') : 'default';
        let currTitle = $currEl.data('title');
        let currLink = $currEl.data('link');
        let currIcon = $currEl.data('icon') ? $currEl.data('icon') : '';
        let currActive = $currEl.hasClass('_active') ? '_hover' : '';

        _lat = parseFloat($currEl.data('coords').split(',')[0]);
        _lng = parseFloat($currEl.data('coords').split(',')[1]);

        $currEl.attr('data-index', index);

        // формируем шаблон метки
        let placemarkData = {
            iconLayout: ymaps.templateLayoutFactory.createClass(
                `<div class="map-point _${currType}  marker-w-label--${index} ${currActive}">
                    <div class="map-point__icon-wrap">
                        <div class="map-point__icon" style="background-image: url('${currIcon}')">
                    </div>
                    </div>

                    <div class="map-point__content">
                        ${currTitle}
                    </div>
                </div>
            `),
            iconOffset: [-32, -32],
            iconShape: {
                type: 'Circle',
                coordinates: [32, 32],
                radius: 32
            }
        };

        // создаем саму метку на основании ее шаблона
        allPlacemarks[index] = new ymaps.Placemark(
            [_lat, _lng], {
                id: _id
            },
            placemarkData
        );

        // клик на метку
        allPlacemarks[index].events.add('click', function () {
            if (!!currLink) {
                window.location.href = currLink;
            } else {
                if (currType != 'logo' && currType != 'default') {
                    $markersPopup.removeClass('_open');
                    $markersPopup.filter(`[data-index=${index}]`).addClass('_open');
                }
            }
        });

        let eventHoverType = App.mobile ? 'click' : 'mouseenter';

        //allPlacemarks[index].events.add('mouseenter', function () {
        allPlacemarks[index].events.add(eventHoverType, function () {
            App.H.find(`.map-point`).removeClass('_hover');
            App.H.find(`.marker-w-label--${index}`).addClass('_hover');

            // z-index
            if (App.mobile && allPlacemarks.length > 1) {
                allPlacemarks.forEach(pm => {
                    pm.options.set('zIndex', 2500);
                });
                allPlacemarks[index].options.set('zIndex', 2501);
            }
        });

        if (!App.mobile) {
            allPlacemarks[index].events.add('mouseleave', function () {
                App.H.find(`.marker-w-label--${index}`).removeClass('_hover');
            });
        } else {
            _map.events.add('click', function () {
                App.H.find(`.map-point`).removeClass('_hover');
            });
        }

        // добавляем метку на карту
        _map.geoObjects.add(allPlacemarks[index]);
    });


    if ($markersPopup.length > 1 && $mapWrapper.data('zoom')) {
        // Если меток много и зум указан, используем его
        // Если центр есть, используем его, если нет — последнюю точку
        _map.setCenter(mapCenter ? mapCenter : [_lat, _lng], mapZoom);
    } else if ($markersPopup.length > 1) {
        // Если меток много и зум не указан, подгоняем карту
        map.setBounds(map.geoObjects.getBounds());
    } else {
        // Если метка одна, центрируем по ней
        _map.setCenter([_lat, _lng], mapZoom);
    }


    if (App.ie || App.edge) {
        setTimeout(function () {
            $('.map-point').each(function (index, el) {
                let $curPoint = $(el);
                let currWidth = $curPoint.find('.map-point__content').outerWidth();

                $curPoint.css({
                    width: currWidth + 45 + 'px'
                });
            });
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./_src/js/modules/Maps.js